import Resource from "../base/resource";
import {buttonEnum} from "../../../components/Buttons/helper";

class Audio extends Resource {
    name;
    resourceId;

    constructor({id, type, resourceId}) {
        super({id, type});
        const audioData = audioFeature.getAudioDataByID(resourceId);
        this.name = window.noserver ? this.id : audioData ? audioData.name : undefined;
        this.audioData = audioData;
        this.resourceId = resourceId;
    }

    async load(onLoadCallback) {
        if (wv.effectController.stoppedTrainingId === TrainingTreeController._trainingFeature.getActiveTraining()?.id) {
            return;
        }
        const audioData = await audioFeature.getAudioDataByID(this.resourceId);
        const location = audioData ? "audio\\" + audioData._id + "&updatedAt=" + audioData.updatedAt : this.name;
        this._audio = new window.Audio();
        this._audio.preload = "auto";
        this._audio.currentTime = 0;
        this._audio.src = location;
        this._audio.load();

        return await new Promise(((resolve, reject) => {
            const taskForLoadedAudio = () => {
                onLoadCallback(1);
                resolve();
                this._audio.removeEventListener('canplaythrough', taskForLoadedAudio);
                this._audio.removeEventListener('loadedmetadata', taskForLoadedAudio);
            };

            this._audio.addEventListener('canplaythrough', taskForLoadedAudio);
            this._audio.addEventListener('loadedmetadata', taskForLoadedAudio);

            this._audio.addEventListener('error', event => {
                reject(new Error(`Failed to load audio. ${event.target.error.message}`));
            });
        }));
    }

    async play() {
        this._audio.currentTime = 0;
        let startPlayPromise = this._audio.play();

        if (startPlayPromise !== undefined) {
            startPlayPromise
                .then(() => {
                    return startPlayPromise;
                })
                .catch((error) => {
                    if (error.name !== "NotAllowedError") {
                        console.log("Audio ", error.name);
                        return;
                    }

                    console.log("Audio Not allowed");
                    const playButton = buttonController.getButtonByName(buttonEnum.PLAY);
                    playButton.initiateAudio(this._audio);
                });
        }
    }

    async stop() {
        this._audio.pause();
        this._audio.currentTime = 0;
    }

    setState() {
    }

    getDefaultState() {
        return {};
    }
}

export default Audio;
